// src/PublicAgencyPage.js
import React from 'react';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EnhancedAgencyPageDesktop from '../../../Agency/rosterViewComps/desktopView';
import EnhancedAgencyPageMobile from '../../../Agency/rosterViewComps/mobileView';

/**
 * Main PublicAgencyPage component that routes to device-specific viewers
 * Enhanced with roster settings integration and modern responsive design
 */
export default function PublicAgencyPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
  // Route to appropriate viewer based on device
  return isMobile ? <EnhancedAgencyPageMobile /> : <EnhancedAgencyPageDesktop />;
}